<template>
  <v-container fluid class="event" v-if="event">
    <div v-if="isLiveEventPage && liveStream" class="stream-eventinfo-switcher">
      <span :class="['tab', { active: !isLiveStreamVisible }]" @click.stop="showEventInfo()"><icon name="icon-information" colorName="white"></icon> Back to Event Info</span>
      <span :class="['tab', { active: isLiveStreamVisible }]" @click.stop="showLiveStream()"><v-icon>play_arrow</v-icon> Watch Live</span>
    </div>

    <template v-if="!isLiveStreamVisible || !isLiveEventPage || !liveStream">
      <template v-if="betRadarId">
        <template v-if="liveEvent && liveEvent.idfoevent">
          <!--<section class="competition-name"  :class="{'competitionname-betradar-id': betRadarId}">{{ liveEvent && liveEvent.competitionname || event && event.sportname }}</section>-->
          <bet-radar-widget isLive="true" :competition="liveEvent && liveEvent.competitionname"></bet-radar-widget>
        </template>
        <template v-else>
          <bet-radar-widget :competition="liveEvent && liveEvent.competitionname"></bet-radar-widget>
        </template>
      </template>
      <!-- not having betRadarId -->
      <template v-else>
        <div class="event_header">
          <div class="competition-live" :class="[{'pre-match': !liveEvent}, {'live-match': liveEvent}]">
            <section class="competition-name" ><span>{{ event && event.fosportname || event.sportname }}</span></section>
            <!-- <section class="live-event" v-if="liveEvent"><div>LIVE</div></section> -->
          </div>
          <!-- Live event info -->
          <div class="event-info" v-if="liveEvent">
            <live-event-info :event="liveEvent" page="'event'"></live-event-info>
          </div>
          <!-- Prematch event info -->
          <div class="event-info" v-if="!liveEvent">
            <template v-if="event.participantname_away && event.participantname_home">
              <section class="parent">
                <section class="child child-left">
                  <div class="team-title">{{ event.participantname_away }} <p v-if="event.awaypitchername" class="smaller">{{ event.awaypitchername | lowercase }}</p></div>
                </section>
                <section class="child child-center">
                  <div>
                    <span class="time">{{ event.tsrealstart | moment(dateFormats.longTime) }}</span>
                    <span class="day">{{ event.tsrealstart | moment(dateFormats.dayAndMonth) }}</span>
                  </div>
                </section>
                <section class="child child-right">
                  <div class="team-title">{{ event.participantname_home }} <p v-if="event.homepitchername" class="smaller">{{ event.homepitchername | lowercase}}</p></div>
                </section>
              </section>
            </template>
            <h3 v-if="!event.participantname_away || !event.participantname_home">{{ event.name }}</h3>
          </div>
        </div>
      </template>
    </template>
    <div v-if="isLiveStreamVisible && isLiveEventPage && liveStream" class="video-streaming">
      <LiveVideoStreaming v-if="isLiveStreamVisible" :livestream="liveStream"></LiveVideoStreaming>
    </div>

    <!-- Show Eventmarketgroups in tabs -->
    <div class="tabs-wrapper clearfix" :class="{'betradar-id' :betRadarId}">
      <v-tabs :class="['eventmarketgroups-tab', {'have-bet-radar-id':betRadarId }, {'with_more_btn': eventmarketgroups.length > numberOfTabs}]">
        <v-tab :class="['sport', 'tab', {'active': eventmarketgroup.idfwmarkettypeclassgroup === selectedIDFWMarkettypeclassGroup }]"
               v-for="(eventmarketgroup) in eventmarketgroups" :key="eventmarketgroup.idfwmarkettypeclassgroup"
               @click.stop="selectEMG(eventmarketgroup.idfwmarkettypeclassgroup)">{{ eventmarketgroup.name }}</v-tab>
      </v-tabs>
    </div>
    <div class="eventmarketgroup marketgroup" :class="{'betradar-id' :betRadarId}" v-if="selectedEventMarketGroup" :key="selectedEventMarketGroup.idfwmarkettypeclassgroup">
      <!-- <markets :markets="filteredBig3MarketsWholeGame" v-if="filteredBig3MarketsWholeGame"
        :event="event"
        :diplayOnPage="'live-single-event'"
        :pricechangehighlight="isLiveEventPage"></markets> -->
      <markets :markets="gamePeriodMarkets" v-if="filteredBig3MarketsPerPeriod" v-for="(gamePeriodMarkets, key) in filteredBig3MarketsPerPeriod" :key="key"
            :event="event"
            :diplayOnPage="'live-single-event'"
            :pricechangehighlight="isLiveEventPage"></markets>

      <div :class="['event-market-header', {'last': index === filteredNonBig3Markets.length - 1}, {'available-for-bb': market.BB} ]" v-for="(market, index) in filteredNonBig3Markets" :key="index">
        <div class="market-name" :class="[{'expanded-market': expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket]  && index !== 0 || expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] !== false && index === 0}]" @click.stop="toggleExpandMarket(selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket, index, market.idfomarket)">
          <h4 class="market-name-title">{{ market.name}}</h4>
          
          <span class="flex icon-span">
                  <span v-if="market.BB" class="available-for-bb"></span>
                  <icon v-if="!expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] && index !== 0" name="icon-market-expand"></icon>
                  <icon v-if="expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket]  && index !== 0" name="icon-market-collapse"></icon>
                  <icon v-if="expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] !== false && index === 0" name="icon-market-collapse"></icon>
                  <icon v-if="expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] === false && index === 0" name="icon-market-expand"></icon>
                  </span>
            </div>
            <markets :markets="[market]" v-if="(index === 0 && expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] !== false) ||
              expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket]"
              :event="event"
              :diplayOnPage="'live-single-event'"
              :pricechangehighlight="isLiveEventPage"></markets>
      </div>
    </div>
  </v-container>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import lib from '@/library'
  import config from '@/config'

  import markets from '@/components/sports/bettingoffer/markets'
  import betRadarWidget from '@/components/sports/bettingoffer/betRadarWidget'
  import LiveVideoStreaming from '@/components/sports/bettingoffer/live/LiveVideoStreaming'
  import LiveEventInfo from '@/components/sports/bettingoffer/live/liveEventInfo'

  import BettingOffer from '@/components/mixins/BettingOffer'
  import Screen from '@/components/mixins/Screen'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'event',

    components: {
      markets,
      LiveEventInfo,
      betRadarWidget,
      Icon,
      LiveVideoStreaming
    },

    mixins: [
      BettingOffer,
      Screen
    ],

    data () {
      return {
        periodicalUpdateTimeout: undefined,
        prematchPeriodicalUpdateInterval: 60000,
        livePeriodicalUpdateInterval: 10000,
        isPeriodicalUpdateStarted: false,
        selectedIDFWMarkettypeclassGroup: 0,
        collapsed: true,
        expandedMarkets: {},
        isLiveStreamVisible: false
      }
    },

    metaInfo () {
      return {
        title: this.metaTitle,
        meta: [
          { description: this.metaDescription }
        ]
      }
    },

    computed: {
      metaTitle () {
        if (this.event && this.event.name) {
          return `${this.event.name} Betting Odds | Bet on ${this.event.sportname} with Fanduel Sportsbook`
        } else {
          return 'Sports betting'
        }
      },
      metaDescription () {
        return config.app.pageMeta.eventPage.description
      },
      hasBetRadarId () {
        return true
      },
      idfoevent () {
        var idfoevent = this.$route.params.idfoevent && this.$route.params.idfoevent.toString()
        if (idfoevent && idfoevent.indexOf('.') === -1) {
          idfoevent += '.1'
        }

        return idfoevent
      },
      betRadarId () {
        if (this.event && this.event.origin) {
          return this.event.origin
        }
      },
      event () {
        return store.getters['eventState/getEvent']
      },
      liveEvent () {
        var self = this
        return this.liveEvents.find(ev => ev.idfoevent.toString() === self.idfoevent.toString() || (ev.foeventantepost && ev.foeventantepost.toString() === self.idfoevent.toString()))
      },
      eventmarketgroups () {
        if (this.event.eventmarketgroups) {
          var eventmarketgroups = Vue._.orderBy(this.event.eventmarketgroups, 'internalorder', 'asc')

          if (!this.selectedIDFWMarkettypeclassGroup && eventmarketgroups.length > 0) {
            this.selectedIDFWMarkettypeclassGroup = eventmarketgroups[0].idfwmarkettypeclassgroup
          }
          return eventmarketgroups
        } else {
          return []
        }
      },
      selectedEventMarketGroup () {
        if (this.eventmarketgroups) {
          return this.eventmarketgroups.find(emg => emg.idfwmarkettypeclassgroup === this.selectedIDFWMarkettypeclassGroup)
        }

        return []
      },
      filteredBig3MarketsPerPeriod () {
        var markets = (this.selectedEventMarketGroup &&
          this.selectedEventMarketGroup.markets &&
          this.selectedEventMarketGroup.markets[0] &&
          ['SOCCER', 'TENNIS'].indexOf(this.selectedEventMarketGroup.markets[0].idfosporttype) === -1 &&
          this.selectedEventMarketGroup.markets.filter(mk => mk.big3markettype)) || []

        var marketsPerPeriod = Vue._.groupBy(markets, 'gameperiodname')
        return marketsPerPeriod
      },
      filteredBig3MarketsWholeGame () {
        return (this.selectedEventMarketGroup &&
          this.selectedEventMarketGroup.markets &&
          this.selectedEventMarketGroup.markets[0] &&
          ['SOCCER', 'TENNIS'].indexOf(this.selectedEventMarketGroup.markets[0].idfosporttype) === -1 &&
          this.selectedEventMarketGroup.markets.filter(mk => mk.big3markettype)) || []
      },
      filteredNonBig3Markets () {
        return this.selectedEventMarketGroup &&
          this.selectedEventMarketGroup.markets &&
          this.selectedEventMarketGroup.markets.filter(mk => !this.filteredBig3MarketsWholeGame || this.filteredBig3MarketsWholeGame.lenght === 0 || this.filteredBig3MarketsWholeGame.filter(b3mk => b3mk.idfomarket === mk.idfomarket).length === 0)
      },
      isLiveEventPage () {
        return this.liveEvent !== undefined
      },
      isEmptyEventmarketgroups () {
        return Vue._.isEmpty(this.eventmarketgroups)
      },
      moreButtonState () {
        var linksInMoreTab = []
        for (var i = 0; i < this.eventmarketgroups.length; i++) {
          if (i > 4 && (this.selectedIDFWMarkettypeclassGroup === this.eventmarketgroups[i].idfwmarkettypeclassgroup)) {
            linksInMoreTab.push(i)
          }
        }
        if (linksInMoreTab.length > 0) {
          return 'active'
        }
      },
      liveStreams () {
        return store.getters['livebettingState/liveStreams']
      },
      liveStream () {
        return this.liveStreams && this.liveStreams.find(ls => ls.idfoevent === this.event.idfoevent)
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      }
    },

    methods: {
      toggleExpandMarket (id, index, idfomarket) {
        if (index === 0 && this.expandedMarkets[id] === undefined) {
          Vue.set(this.expandedMarkets, id, false)
        } else {
          Vue.set(this.expandedMarkets, id, !this.expandedMarkets[id])
        }
      },
      startEventByIdUpdate (idfoevent) {
        this.isPeriodicalUpdateStarted = true
        clearTimeout(this.periodicalUpdateTimeout)

        store.dispatch('eventState/fetchEventById', { idfoevent: idfoevent, isliveevent: this.isLiveEventPage }).then(() => {
          this.periodicalUpdateTimeout = setTimeout(() => {
            if (this.isPeriodicalUpdateStarted) {
              this.startEventByIdUpdate(idfoevent)
            }
          }, this.isLiveEventPage ? this.livePeriodicalUpdateInterval : this.prematchPeriodicalUpdateInterval)
        })
      },
      stopEventByIdUpdate () {
        this.isPeriodicalUpdateStarted = false
        clearTimeout(this.periodicalUpdateTimeout)
      },
      clearCachedEvents () {
        store.dispatch('eventState/clearCachedEvent')
      },
      selectEMG (idfwmarkettypeclassgroup) {
        this.selectedIDFWMarkettypeclassGroup = idfwmarkettypeclassgroup
      },
      subscribeToLiveEventMarkets () {
        if (this.idfoevent) {
          lib.WebSocketLiveService.subscribeToEventsMarkets([this.idfoevent], 'ISLIVE', 6)
        }
      },
      unsubscribeFromLiveEventMarkets () {
        lib.WebSocketLiveService.unsubscribeFromEventPageMarkets()
      },
      showLiveStream () {
        this.isLiveStreamVisible = true
      },
      showEventInfo () {
        this.isLiveStreamVisible = false
      }
      // preselectNav (liveEventPage) {
      //   setTimeout(() => {
      //     if (liveEventPage) {
      //       let mainNav = document.querySelector('.main-navigation [href="/live"]')
      //       document.querySelector('.main-navigation .router-link-active').classList.remove('router-link-exact-active', 'router-link-active')
      //       mainNav.classList.add('router-link-exact-active', 'router-link-active')
      //     } else {
      //       let mainNav = document.querySelector('.main-navigation [href="/sports"]')
      //       document.querySelector('.main-navigation [href="/live"]').classList.remove('router-link-exact-active', 'router-link-active')
      //       mainNav.classList.add('router-link-exact-active', 'router-link-active')
      //     }
      //   }, 0)
      // }
    },

    created () {
      this.clearCachedEvents()
      this.startEventByIdUpdate(this.idfoevent)

      if (this.isLiveEventPage) {
        // this.preselectNav(this.isLiveEventPage)
        this.subscribeToLiveEventMarkets()
      }
    },

    destroyed () {
      // this.preselectNav(false)
      this.clearCachedEvents()
      this.stopEventByIdUpdate()
      this.unsubscribeFromLiveEventMarkets()
    },

    watch: {
      idfoevent () {
        this.clearCachedEvents()
        this.startEventByIdUpdate(this.idfoevent)
        this.selectedIDFWMarkettypeclassGroup = 0
      },
      isLiveEventPage (newVal) {
        if (newVal) {
          this.startEventByIdUpdate(this.idfoevent)
          this.subscribeToLiveEventMarkets()
        }
      },
      isLoggedIn (newVal) {
        // if user logs in when on livestream, livestream will switch to event info
        if (newVal && this.isLiveStreamVisible) {
          this.showEventInfo()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  @import "~@/css/config.styl"


  .competition-title
    font-size 14px
    opacity .6
    color #fff
    text-align left
    margin-left 20px


  .eventmarketgroups-tab.have-bet-radar-id
    /*border 1px solid red*/
    margin-top: 84px
    /*z-index: 1*/

   .sr-lmt-plus-lmtpitch {
     margin-top 95px
   }

   .sr-lmt__content.srt-base-1 {
     margin-top 97px
   }

  .competition-live.pre-match {
    margin: 76px 0 14px 0
  }

  .competition-live.live-match {
    margin-top 75px
  }

  .competition-live {
    display: flex
    justify-content: space-between
    margin-top 49px
    background-color: #152a47
  }

  .competition-name.competitionname-betradar-id {
    display none
  }
  #app .team-title {
    padding-left 0px
  }

  .live-event {
    margin-right 0px
  }

  .live-event div {
    margin-right: 5px
    font-family: font-family-igt-condensed
    font-size 14px
    color:#FFFFFF
    background-color: #DB3F3F
    border-radius: 5px
    line-height: 26px;
    padding: 0px 15px;
  }

  .eventmarketgroups-tab.have-bet-radar-id {
    margin-top  0
    }

  .event
    position relative
    .competition-name
      font-family font-family-igt
      font-size 18px
      color rgba(255, 255, 255, .6)
      text-align left
      line-height 14px
      cursor default
      font-weight 100
      div
        padding-top 6px
    .event-info
      height 125px
      cursor default
      margin-bottom 4px
      @media mobile-big-and-below
        height auto
        background-color: #152a47

  >>>.tabs__bar
    .tabs__wrapper
      .tabs__container
        // height 66px !important

  .more_tabs
    background: #152a47
    border-radius: 60px
    text-align: center
    padding: 8px 16px
    height: 36px
    color: #fff
    display: flex
    margin-top: 15px
    margin-left: 90px
    margin-right: 12px
    >>>.igt-icon
      visibility: visible
    >>>.igt-icon > span
      height: 9px
      margin-left: 2px
    span
      font-family: font-family-igt
      font-size: 16px
      line-height: 22px

  .more_tabs.active
    background: #1493FF
  .menu__activator--active .more_tabs
    background: #1493FF
  .list
    padding: 0
    font-size: 14px
    color: #1F375B !important
    border-radius: 4px !important
  .list:hover
      border-radius: 4px !important

    .sporttab-li:hover
      border-radius: 4px

    >>>.list__tile
      color: #1F375B
      font-size: 14px
      &:hover
        color: #2396FC
        background: #fff !important
    .list_title
      flex: 1 1 auto

    .sporttab-li .igt-icon
        margin-left: auto
        visibility: hidden

    .sporttab-li.active
      >>>.list__tile
        color: #2396FC !important
        font-weight: bold
        background: #fff !important
        .igt-icon > span
          visibility: visible


@media mobile-big-and-below
        height: 266px
      .parent
        display flex
        flex-flow row nowrap
        height 100%
        /*padding-top 20px*/
        .child
          width 49%
          height 40%
          color white
          font-size 20px
          line-height 23px
          .team-title
            color white
            line-height 23px
            margin-bottom: 10px
            padding-left 20px
          .smaller
            font-size 12px
            text-transform capitalize
        .child-left
          text-align left
          .team-title
            font-size 20px
          /*padding-left 12px*/
          font-family font-family-igt
        .child-right
          font-size 28px
          text-align right
          padding-top 5px
          .day
            display block
            font-family font-family-igt
            font-size 14px
    .eventmarketgroup
      padding-top 5px

  .eventmarketgroup-name
    cursor: pointer;
    border: solid 1px #ccc;
    padding: 8px;

  .tab
    border: solid 1px #999;
    padding: 5px;
    margin: 5px;
    cursor: pointer;

  .time-period
    color #828282
    font-size 20px
    line-height 23px
    margin-bottom 0

  .result-title
    color #4F4F4F
    font-size 32px
    line-height 38px
    margin-bottom 5px

  .live-details
    font-family Arial
    font-weight bold
    color #000
    font-size 10px
    line-height 12px
    display block
    text-align center
    cursor pointer

  .live-data
    background-color #4F4F4F
    color #fff
    width 100%
    height 200px
    text-align center
    line-height 200px

  .competition-name
    /*display block*/
    font-family Arial
    font-weight bold
    color #828282
    font-size 14px
    line-height 16px

   @media mobile-big-and-below
    .team-title
      font-size 14px
      line-height 16px
    .time-period
      color #828282
      font-size 14px
      line-height 16px

    .result-title
      font-size 20px
      line-height 23px
      margin-bottom 0

    .live-details
      display none

    .competition-name.competitionname-betradar-id
      display none

    .competition-live
      margin-top: 0

    .live-event
      border-radius 4px
      font-family font-family-igt-condensed
      font-size 12px

    .event .event-info
      margin-bottom 1px


    .eventmarketgroup
      display block
      width 100%
      background #e6e8ed

@media mobile-big-and-below
  >>>.tabs__bar .tabs__wrapper .tabs__container {
    height 48px !important
  }
  .time {
    font-size 14px
  }
  .day {
    font-family font-family-igt
    font-size 14px
  }

  .competition-live.pre-match {
    margin: 0
  }

  .competition-live.live-match {
    margin: 0
  }

  .event-info {
    margin-bottom: 50px
  }

  .competition-title {
    text-align: left
    margin-left: 20px
  }
  .event .competition-name {
    font-size 14px
  }

  #app .team-title {
    padding-left 20px
    font-size 14px
    }

  .child.child-right {
    /*margin-top: 0px*/
    padding-top: 0px
  }

  .live-event {
    margin-right : 3px
  }

.eventmarketgroup
  .event-market-header + .event-market-header
    margin-top: 4px
  .event-market-header
    &.available-for-bb
      .icon-span
        float right
        .igt-icon
          position relative
          top -5px
    .market-name
      display flex
      background #fff
      border 1px solid #cfd6db
      border-radius 4px
      height: 40px
      padding 10px 15px
      margin: 0
      color #21335a
      font-family font-family-igt
      cursor: default
      margin-bottom: -2px
      &:hover
        cursor: pointer
      &.expanded-market
        border-bottom-left-radius 0
        border-bottom-right-radius 0
      @media mobile-big-and-below
        margin-left: 4px
        margin-right: 4px
      .market-name-title
        font-size: 14px
        margin: 0px
        font-weight: bold
        font-style: normal
        font-stretch: normal
        line-height: normal
      .icon-span
        text-align: right
      .available-for-bb
        display inline-block
        width 17px
        height 17px
        background-repeat no-repeat
        margin-right 5px
        vertical-align middle
  .event-market-header.last
    margin-bottom: 4px

.eventmarketgroup * {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: -moz-none;
    -o-user-select: none;
    user-select: none;
}

.stream-eventinfo-switcher
  background #152a47
  margin-top -1px
  padding 0 0 10px 0
  margin-bottom -59px
  @media mobile-big-and-below
    display flex
    justify-content center
    margin-bottom 0px
    padding 10px 15px
  .tab
    background-color #3fc369
    color #fff
    border-radius: 2px
    border none
    height 44px
    display inline-flex
    align-items center
    justify-content: center
    min-width 137px
    width auto
    margin 5px 0
    font-size 14px
    position relative
    z-index 2
    font-family font-family-igt-bold
    @media mobile-big-and-below
      width 100%
    .icon
      color #fff
      font-size 15px
      border-radius 50%
      border 1px solid white
      margin-right 5px
    >>>.igt-icon > span
      margin-right 5px
  .tab.active
    // background-color #e4e8ee
    // color #1f375b
    display none


.video-streaming
  // padding-top 50px
  // padding-bottom: 10px
  // width 25vw
  width 60%
  max-width calc(100% - 150px)
  margin auto
  min-height 239px
  @media mobile-big-and-below
    padding: 0
    width: 100%
    min-height unset
    max-width 100%

  @media only screen and (min-width: 1024px) and (max-width: 1280px)
    padding-left 100px
    width 80%


</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/Event.vue